module.exports = __webpack_public_path__ + "img/delivery-time_product.58c4485a.png";